import classNames from "classnames";
import * as React from "react";
import { Link } from "react-router-dom";
import { TaxedMoney } from "@components/containers";
import { Thumbnail } from "@components/molecules";
import { generateProductUrl } from "../../core/utils";

var ProductRow = function ProductRow(_ref) {
  var mediumScreen = _ref.mediumScreen,
      processing = _ref.processing,
      line = _ref.line;
  var productUrl = generateProductUrl(line.product.id, line.product.name);
  return React.createElement("tr", {
    className: classNames({
      "cart-table-row--processing": processing
    })
  }, React.createElement("td", {
    className: "cart-table__thumbnail"
  }, React.createElement("div", null, mediumScreen && React.createElement(Link, {
    to: productUrl
  }, React.createElement(Thumbnail, {
    source: line.product
  })), React.createElement(Link, {
    to: productUrl
  }, line.product.name))), mediumScreen && React.createElement("td", null, React.createElement(TaxedMoney, {
    taxedMoney: line.pricing.price
  })), React.createElement("td", null, line.attributes.map(function (_ref2, attributeIndex) {
    var attribute = _ref2.attribute,
        values = _ref2.values;
    return React.createElement("p", {
      key: attribute.id
    }, attribute.name, ": ", values.map(function (value) {
      return value.name;
    }).join(", "));
  })), React.createElement("td", {
    className: "cart-table__quantity-cell"
  }, React.createElement("p", null, line.quantity)), React.createElement("td", {
    colSpan: 2
  }, React.createElement(TaxedMoney, {
    taxedMoney: line.totalPrice
  })));
};

export default ProductRow;